<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del" @execute="execute" @print='print'
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <el-tabs :tab-position="'top'" type="" @tab-click="selectInfo">
                    <el-tab-pane :label="$t('getapi[4586]')" name="0">
                        <wTable
                                id="xpane-0"
                                :data="dataSet"
                                :loading="loading"
                                queryData="ProSOCollecIssueHeadJichengViewInfo"
                                :filter_language="['finance_status','order_statusname','negative_flag']"
                                :header="tableHeader"
                                :option="tableOption"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                ref="singleTable"
                                :checkflg="false"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet"
                                ref="singleTable"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                :height="tableHeight - reduceTableHeight"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[3728]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_statusname" :label="$t('getapi[1861]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_status" :label="$t('getapi[1862]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_date" :label="$t('getapi[1857]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="issue_dept" :label="$t('getapi[2180]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[3690]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[4583]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[1210]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[4584]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_time" :label="$t('getapi[4585]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="regist_person" :label="$t('getapi[1747]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_person" :label="$t('getapi[1864]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="negative_flag" :label="$t('getapi[2096]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="base_order_no" :label="$t('getapi[2203]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                        </el-table>-->
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[1422]')" name="1">
                        <wTable
                                id="xpane-1"
                                :data="dataSet1"
                                :loading="loading"
                                queryData="ProSOCollecIssueHeadJichengViewInfo"
                                :filter_language="['finance_status','order_statusname','negative_flag']"
                                :header="tableHeader"
                                :option="tableOption"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                ref="singleTable1"
                                :checkflg="false"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet1"
                                ref="singleTable1"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                :height="tableHeight - reduceTableHeight"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[3728]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_statusname" :label="$t('getapi[1861]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_status" :label="$t('getapi[1862]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_date" :label="$t('getapi[1857]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="issue_dept" :label="$t('getapi[2180]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[3690]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[4583]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[1210]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[4584]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_time" :label="$t('getapi[4585]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="regist_person" :label="$t('getapi[1747]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_person" :label="$t('getapi[1864]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="negative_flag" :label="$t('getapi[2096]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="base_order_no" :label="$t('getapi[2203]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                        </el-table>-->
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[4587]')" name="2">
                        <wTable
                                id="xpane-2"
                                :data="dataSet2"
                                :loading="loading"
                                queryData="ProSOCollecIssueHeadJichengViewInfo"
                                :filter_language="['finance_status','order_statusname','negative_flag']"
                                :header="tableHeader"
                                :option="tableOption"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                ref="singleTable2"
                                :checkflg="false"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet2"
                                ref="singleTable2"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                :height="tableHeight - reduceTableHeight"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[3728]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_statusname" :label="$t('getapi[1861]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_status" :label="$t('getapi[1862]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_date" :label="$t('getapi[1857]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="issue_dept" :label="$t('getapi[2180]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[3690]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[4583]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[1210]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[4584]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_time" :label="$t('getapi[4585]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="regist_person" :label="$t('getapi[1747]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_person" :label="$t('getapi[1864]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="negative_flag" :label="$t('getapi[2096]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="base_order_no" :label="$t('getapi[2203]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                        </el-table>-->
                    </el-tab-pane>
                </el-tabs>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div class="btnnowrap">
                    <el-button type="primary" size="mini" @click="collsoPrint" :disabled="dataDetail.Head.order_no == ''">{{
                        $t('getapi[940]') }}
                    </el-button>
                </div>
                <div>
                    <div style="width:780px;min-width:780px">
                        <table>
                        <tr>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[2095]') }}</td>
                            <td style="width:150px;min-width:150px">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.order_no" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[1861]') }}</td>
                            <td style="width:150px;min-width:150px">
                                <el-input type="text" size="mini" :value="expStatus(dataDetail.Head.order_status)" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[1862]') }}</td>
                            <td style="width:150px;min-width:150px">
                                <el-input type="text" size="mini" :value="expFinanceStatus(dataDetail.Head.finance_status)" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:150px;min-width:150px"></td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[4470]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.regist_person" :readonly="true" class="readO" v-show="dataDetail.Head.order_status != 0"></el-input>
                                <routejump :urlNo="6" v-show="dataDetail.Head.order_status == 0">
                                <el-input  type="text" v-model="dataDetail.Head.regist_person"
                                           readonly
                                           size="mini"
                                           class="mcolor"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectperson(2)"></i>
                                </el-input>
                                </routejump>
                            </td>
                            <td>{{ $t('getapi[4472]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.keep_person" :readonly="true" class="readO" v-show="dataDetail.Head.order_status != 0"></el-input>
                                <routejump :urlNo="6" v-show="dataDetail.Head.order_status == 0">
                                <el-input  type="text" v-model="dataDetail.Head.keep_person"
                                           readonly
                                           size="mini"
                                           class="mcolor"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectperson(1)"></i>
                                </el-input>
                                </routejump>
                            </td>
                            <td>{{ $t('getapi[4469]') }}</td>
                            <td>
                                <routejump :urlNo="36">
                                <el-select filterable v-model="dataDetail.Head.issue_dept" size="mini" v-if="dataDetail.Head.order_status == 0" class="mcolor">
                                    <el-option v-for="item in issueDeptType" :key="item.Name" :label="item.Name"
                                               :value="item.Name"></el-option>
                                </el-select>
                                <el-select filterable v-model="dataDetail.Head.issue_dept" size="mini" v-if="dataDetail.Head.order_status != 0" :disabled="true">
                                    <el-option v-for="item in issueDeptType" :key="item.Name" :label="item.Name"
                                               :value="item.Name"></el-option>
                                </el-select>
                                </routejump>
                            </td>
                            <td>
                                <el-checkbox  v-model="dataDetail.Head.negative_flag"  :true-label=1 :false-label=0 :disabled="true"></el-checkbox>{{ $t('getapi[2096]') }}
                            </td>
                        </tr>
                    </table>
                    </div>
                    <el-tabs :tab-position="'top'" type="" style="margin-top: 0px" @tab-click="selectInfo1">
                        <el-tab-pane :label="$t('getapi[4589]')" name="0">
                            <div>
                                <el-button type="primary" size="mini" @click="selectsocode" :disabled="dataDetail.Head.order_status != 0">{{ $t('getapi[12992]') }}
                                </el-button>
                                <el-button type="primary" size="mini" @click="selectsocode_assist" :disabled="!btn.assistsadd">{{ $t('getapi[12993]') }}
                                </el-button>
                                <el-button type="primary" size="mini" @click="batchDel" :disabled="!btn.batchdelmaster">{{
                                    $t('getapi[1522]') }}
                                </el-button>
                            </div>
                            <el-table
                                    id="xdetilpane-0"
                                    :data="dataDetail.MasterLists"
                                    :row-class-name="tableRowClassNameDetailMaster"
                                    @selection-change="handleSelectionChangeMaster"
                                    :highlight-current-row="true"
                                    :height="tableHeight - 180"
                                    header-row-class-name="headerclass"
                                    border
                                    size="mini"
                                    style="width: 100%; margin-top:3px"
                                    ref="singleTable3"
                            >
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4168]')" width="150"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="schedule_no" :label="$t('getapi[4236]')" width="150"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="routing_sequence_no" :label="$t('getapi[573]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="routing_desc" :label="$t('getapi[575]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                                <el-table-column prop="mp_flag" :label="$t('getapi[4241]')">
                                    <template scope="scope">
                                        {{scope.row.mp_flag == 0?$t('getapi[235]'):$t('getapi[242]')}}
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="measure_unit" :label="$t('getapi[4590]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="plan_qty" :label="$t('getapi[4904]')" align="right"></el-table-column>
                                <el-table-column prop="actually_avg_qty" :label="$t('getapi[4591]')" align="right">
                                    <template scope="scope">
                                        <span style="color:#ff7879;" v-if="scope.row.actually_avg_qty != scope.row.plan_qty">{{scope.row.actually_avg_qty}}</span>
                                        <span v-if="scope.row.actually_avg_qty == scope.row.plan_qty">{{scope.row.actually_avg_qty}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_stuff" :label="$t('getapi[126]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_model" :label="$t('getapi[124]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_spec" :label="$t('getapi[125]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="cargo_position" :label="$t('getapi[1957]')" width="180"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_engtype_name" :label="$t('getapi[3338]')" width="180"></el-table-column>
                            </el-table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[4592]')" name="1">
                            <div>
                                <el-button type="primary" size="mini" @click="batchDelMerge" :disabled="!btn.batchdelmerge">{{
                                    $t('getapi[1522]') }}
                                </el-button>
                            </div>
                            <el-table
                                    id="xdetilpane-1"
                                    :data="dataDetail.MergeLists"
                                    :row-class-name="tableRowClassNameDetailMerge"
                                    @selection-change="handleSelectionChangeMerge"
                                    :highlight-current-row="true"
                                    :height="tableHeight - 180"
                                    header-row-class-name="headerclass"
                                    border
                                    size="mini"
                                    style="width: 100%; margin-top:5px"
                                    ref="singleTable4"
                            >
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" width="150"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                                <!-- <el-table-column show-overflow-tooltip prop="mp_flag" :label="$t('getapi[134]')"></el-table-column> -->
                                <el-table-column prop="mp_flag" :label="$t('getapi[134]')">
                                    <template scope="scope">
                                        {{scope.row.mp_flag == 0?$t('getapi[235]'):$t('getapi[242]')}}
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_stuff" :label="$t('getapi[126]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_model" :label="$t('getapi[124]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_spec" :label="$t('getapi[125]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="measure_unit" :label="$t('getapi[888]')"></el-table-column>
                                <el-table-column prop="merge_qty" :label="$t('getapi[4593]')" align="right">
                                    <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                        <el-input  type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.merge_qty" @change="mergeQtyCalc(scope)"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="qty_on_hand" :label="$t('getapi[4594]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="assist_merge_qty" :label="$t('getapi[4596]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="assist_measure_unit" :label="$t('getapi[130]')" ></el-table-column>
                                <el-table-column show-overflow-tooltip prop="master_assist_rate" :label="$t('getapi[131]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="createqty" :label="$t('getapi[4523]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="cargo_position" :label="$t('getapi[4522]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_engtype_name" :label="$t('getapi[3338]')" width="180"></el-table-column>
                                <el-table-column prop="area_code" :label="$t('getapi[6900]')">
                                    <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                        <el-select filterable class-name="check" v-model="scope.row.area_code">
                                            <el-option v-for="item in scope.row.areaarr" :key="item" :title="item"
                                                       :value="item" size="mini"></el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                    </el-tabs>
                    <div>
                        <table>
                            <tr>
                                <td style="width:100px">{{ $t('getapi[1890]') }}</td>
                                <td style="width:140px">
                                    <el-input v-model="dataDetail.Head.create_person" size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:100px">{{ $t('getapi[733]') }}</td>
                                <td style="width:140px">
                                    <el-input v-model="dataDetail.Head.modify_person" size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:100px">{{ $t('getapi[4584]') }}</td>
                                <td style="width:140px">
                                    <el-input v-model="dataDetail.Head.audit_person" size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:100px"></td>
                                <td style="width:140px"></td>
                            </tr>
                            <tr>
                                <td>{{ $t('getapi[1859]') }}</td>
                                <td>
                                    <el-date-picker v-model="dataDetail.Head.create_time" type="date" size="mini"
                                                    style="width:100%" :readonly="true" class="readO"></el-date-picker>
                                </td>
                                <td>{{ $t('getapi[1210]') }}</td>
                                <td>
                                    <el-date-picker v-model="dataDetail.Head.modify_time" type="date" size="mini"
                                                    style="width:100%" :readonly="true" class="readO"></el-date-picker>
                                </td>
                                <td>{{ $t('getapi[496]') }}</td>
                                <td>
                                    <el-date-picker v-model="dataDetail.Head.audit_time" type="date" size="mini"
                                                    style="width:100%" :readonly="true" class="readO"></el-date-picker>
                                </td>
                                <td>{{ $t('getapi[1857]') }}</td>
                                <td>
                                    <el-date-picker v-model="dataDetail.Head.finance_date" type="date" size="mini"
                                                    style="width:100%" :readonly="true" class="readO"></el-date-picker>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </li>
        </ul>
        <el-row v-if="SelectIndex == 0" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 1" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize1"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total1"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 2" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange2"
                        @current-change="handleCurrentChange2"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize2"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total2"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="ProSOCollecIssueHeadJichengViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[4009]')" queryData="ProSOCollecIssueHeadJichengViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!--选择SO号-->
        <selectorvxe :isVisible="false" :isBatch=true :postUrl="'/Pro/CollSO/GetCollSOPopupDataList'" @callback="getsocode" ref="socode"></selectorvxe>
    <!--选择SO号-->
        <selectorvxe :isVisible="false" :isBatch=true :postUrl="'/Pro/CollSO/GetCollSOPopupDataList_Assist'" @callback="getsocode_assist" ref="socode_assist"></selectorvxe>
        <!--保管员 记账员-->
        <selector :isVisible="false" :isBatch=false :selectType="3" :isSplitPage=true :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getperson" ref="person"></selector>
        <!--选择货位号-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Inv/Action/GetActCollSORedCPPopupList'" @callback="getcargo" ref="cargo"></selector>
        <!--发料单号-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Inv/Action/GetActCollSOPopupDataList'" @callback="getorderno" ref="orderno"></selector>

        <el-dialog :visible.sync="visProIssueExcute" width="80%" :close-on-click-modal="false" :show-close="false">
            <table>
                <tr>
                    <td style="width:60px">{{ $t('getapi[2255]') }}</td>
                    <td style="width:150px;">
                       <!-- <el-input type="text" size="mini" v-model="dataDetailExcute.Head.order_no" :disabled="true"></el-input>-->
                        <el-input  type="text" v-model="dataDetailExcute.Head.order_no"
                                   readonly
                                   class="mcolor"
                                   size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectorderno"></i>
                        </el-input>
                    </td>
                    <td style="width:60px">{{ $t('getapi[4509]') }}</td>
                    <td style="width:150px;">
                        <el-input type="text" size="mini" v-model="dataDetailExcute.Head.issue_dept" :readonly="true" class="readO"></el-input>
                    </td>
                    <td style="width:100px;"><el-checkbox  v-model="dataDetailExcute.Head.negative_flag"  :true-label=1 :false-label=0 disabled="true"></el-checkbox>{{ $t('getapi[2096]') }}</td>
                </tr>
            </table>
            <el-tabs :tab-position="'top'" type="" style="margin-top: 0px">
                <el-tab-pane :label="$t('getapi[4512]')" name="0">
                    <el-table
                            :data="dataDetailExcute.Lists"
                            :highlight-current-row="true"
                            :height="tableHeight - 255"
                            border
                            size="mini"
                            style="width: 100%; margin-top:3px"
                    >
                        <el-table-column type="selection" v-if="false"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[2239]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" width="150"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_cost" :label="$t('getapi[2248]')" align="right"></el-table-column>
                        <el-table-column prop="batch_no" :label="$t('getapi[1763]')">
                            <template scope="scope" v-if="dataDetail.Head.negative_flag == 1">
                                <el-input  type="text" v-model="scope.row.batch_no" oninput="value=value.replace(/(^\s*)|(\s*$)/g,'')"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sequence_no" :label="$t('getapi[1764]')">
                            <template scope="scope" v-if="dataDetail.Head.negative_flag == 1">
                                <el-input  type="text" v-model="scope.row.sequence_no" oninput="value=value.replace(/(^\s*)|(\s*$)/g,'')"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="is_audit" :label="$t('getapi[2249]')">
                            <template scope="scope" v-if="dataDetail.Head.negative_flag == 0">
                                <el-checkbox  v-model="scope.row.is_audit"  :true-label=1 :false-label=0 disabled="true"></el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="operation_code" :label="$t('getapi[2250]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="direction" :label="$t('getapi[2251]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="trans_qty" :label="$t('getapi[2242]')" align="right"></el-table-column>
                        <el-table-column prop="trans_qty_input" :label="$t('getapi[3103]')" align="right">
                            <template scope="scope" v-if="dataDetail.Head.negative_flag == 0">
                                <el-input  type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.trans_qty_input" @change="changeQtyBlue(scope)"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="measureunit" :label="$t('getapi[888]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="assist_trans_qty" :label="$t('getapi[2244]')" align="right"></el-table-column>
                        <!-- <el-table-column show-overflow-tooltip prop="assist_trans_qty_input" :label="$t('getapi[2245]')" align="right"></el-table-column> -->
                        <el-table-column prop="assist_trans_qty_input" :label="$t('getapi[2245]')" align="right">
                            <template scope="scope" v-if="dataDetail.Head.negative_flag == 0">
                                <template v-if="scope.row.assist_qty_on_hand>0 && scope.row.master_assist_rate>0">
                                    <el-input  type="number" autocomplete="off" title=""  v-model="scope.row.assist_trans_qty_input" @change="changeAssistQtyBlue(scope)" @mousewheel.native.prevent size="mini"></el-input>
                                </template>
                                <template v-else>
                                    <el-table-column show-overflow-tooltip prop="assist_trans_qty_input" :label="$t('getapi[2245]')" align="right"></el-table-column>
                                </template>                                
                            </template>                            
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="assist_measureunit" :label="$t('getapi[130]')" ></el-table-column>
                        <el-table-column show-overflow-tooltip prop="master_assist_rate" :label="$t('getapi[131]')" align="right"></el-table-column>
                               
                        <el-table-column show-overflow-tooltip prop="operation_person" :label="$t('getapi[346]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="trans_time" :label="$t('getapi[2254]')"></el-table-column>
                        <el-table-column prop="remark" :label="$t('getapi[143]')">
                            <template scope="scope">
                                <el-input  type="text" v-model="scope.row.remark"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="cargo_position" :label="$t('getapi[1842]')" width="180">
                            <template scope="scope" v-if="dataDetail.Head.negative_flag == 1">
                                <el-input  type="text" v-model="scope.row.cargo_position"
                                           readonly
                                           class="mcolor"
                                           size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectcargo(scope)"></i>
                                </el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="qty_on_hand" :label="$t('getapi[2240]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="assist_qty_on_hand" :label="$t('getapi[2243]')"></el-table-column>                        
                        <el-table-column show-overflow-tooltip prop="receive_time" :label="$t('getapi[2100]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="expiry_date" :label="$t('getapi[225]')"></el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visProIssueExcute = false" :disabled="!btn.closeExecute">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="saveCollSOActionData(0)" :disabled="!btn.saveCollSOActionData" size="mini">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>
        <el-dialog :visible.sync="visPrintType" width="25%" :close-on-click-modal="false"  :title="$t('getapi[7111]')">
        <el-radio v-model="printflag" label="0">{{ $t('getapi[7112]')}}</el-radio>
        <el-radio v-model="printflag" label="1">{{ $t('getapi[7113]')}}</el-radio>
        <span slot="footer" class="dialog-footer">
            <el-button @click="visPrintType	=	false" size='mini'>{{ $t('getapi[2054]') }}</el-button>
            <el-button type="primary" size='mini' @click="confirmPrint">{{ $t('getapi[7114]')}}</el-button>
        </span>
        </el-dialog>

        <el-dialog :visible.sync="visAddType" width="25%" :close-on-click-modal="false" >
            <el-checkbox  v-model="negativeflag"  :true-label=1 :false-label=0></el-checkbox>{{ $t('getapi[4942]') }}
            <span slot="footer" class="dialog-footer">
				<el-button @click="visAddType = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmAdd">{{ $t('getapi[4943]') }}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="showCollsoPrint" :title="$t('getapi[34]')" width="300px" :close-on-click-modal="false">
            <el-divider></el-divider>
            <div>
                <table>
                    <tr>
                        <td>{{$t('getapi[12749]')}}</td>
                        <td>
                            <el-select v-model="printerid" class="select" @change="changePrinter">
                                <el-option v-for="item in printerArr" :key="item.id" :label="item.name"
                                           :value="item.id"></el-option>
                            </el-select>
                        </td>
                        <td><el-button type="primary" @click="editPrinter" size="mini">{{ $t('getapi[34]') }}</el-button></td>
                    </tr>
                </table>
            </div>
            <el-divider></el-divider>

            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="showCollsoPrint = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="mini" type="primary" @click="confirmCollsoPrint">{{$t('getapi[1146]')}}{{$t('getapi[940]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="showPrinter" :title="$t('getapi[34]')" width="40%" :close-on-click-modal="false">
            <el-divider></el-divider>
            <div>
                <div>
                    <el-button type="primary" size="mini" @click="addPrinter">{{
                        $t('getapi[878]') }}
                    </el-button>
                </div>
                <el-table
                        :data="printerArr"
                        :highlight-current-row="true"
                        :height="300"
                        header-row-class-name="headerclass"
                        border
                        size="mini"
                        style="width: 100%; margin-top:2px"
                >
                    <el-table-column show-overflow-tooltip prop="ip" :label="$t('getapi[12750]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="model" :label="$t('getapi[12751]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="name" :label="$t('getapi[12752]')"></el-table-column>
                    <el-table-column fixed="right" :label="$t('getapi[6048]')" width="150">
                        <template slot-scope="scope">
                            <el-button @click.native.prevent="editPrinter_(scope)" type="text" size="small">{{
                                $t('getapi[34]') }}
                            </el-button>
                            <el-popconfirm
                                    :confirmButtonText="$t('getapi[6109]')"
                                    :cancelButtonText="$t('getapi[6]')"
                                    icon="el-icon-info"
                                    iconColor="red"
                                    :title="$t('getapi[637]')"
                                    @onConfirm="delPrinter_(scope)"
                            >
                                <el-button slot="reference" type="text" size="small">{{ $t('getapi[40]')
                                    }}
                                </el-button>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-divider></el-divider>

            <span slot="footer" class="dialog-footer">
				<el-button  @click="showPrinter = false" size="mini">{{ $t('getapi[6]') }}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="showEditPrinter" :title="$t('getapi[34]')" width="40%" :close-on-click-modal="false">

            <el-divider></el-divider>
            <div :style="{border:'1px solid #DCDFE6'}">
                <table>
                    <tr>
                        <td>{{$t('getapi[12750]')}}</td>
                        <td><el-input v-model="printerDetail.ip" type="text" size="mini"></el-input></td>
                        <td>{{$t('getapi[12751]')}}</td>
                        <td><el-input v-model="printerDetail.model" type="text" size="mini"></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[12752]')}}</td>
                        <td><el-input v-model="printerDetail.name" type="text" size="mini"></el-input></td>
                    </tr>
                </table>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="showEditPrinter = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="mini" type="primary" @click="savePrinter">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: '2_collsoissueview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3- Common.reduceTableHeight2,
                    maxHeight: this.$windowSize.tableHeight3- Common.reduceTableHeight2,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                visPrintType:false,//打印选择弹框
                printflag:'0',
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                dataSet: [], // 主表数据
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('2_collsoissueview'), // 当前页数据量
                total: 0, // 数据总量
                SelectIndex: 0, //当前页面
                RightSelectIndex: '0',
                dataSet1: [], // 主表数据
                pageIndex1: 1, // 当前页
                pageSize1: this.$http.getPageSize('2_collsoissueview1'), // 当前页数据量
                total1: 0, // 数据总量
                dataSet2: [], // 主表数据
                pageIndex2: 1, // 当前页
                pageSize2: this.$http.getPageSize('2_collsoissueview2'), // 当前页数据量
                total2: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight2,
                dataDetail:{
                    Head:{},
                    MasterLists:[],
                    MergeLists:[],
                    LangType:0,
                },
                oldDataDetail: '',
                SignList: [],
                selectData: [],
                selectData1: [],
                selectData2: [],
                selectDataMater:[],
                selectDataMerge:[],
                btn:{
                    batchdelmerge: false,
                    batchdelmaster: true,
                    closeExecute: true,
                    saveCollSOActionData: true,
                    assistsadd:true,
                },
                visProIssueExcute: false, // 生产发料执行弹窗
                visProIssueExcuteRed: false, // 生产发料执行红字弹窗
                rowindex: '',
                oneormore: '',
                rowindexassist: '',
                oneormoreassist: '',
                dataDetailLineNo: 1,
                dataDetailExcute: {
                    Head: {},
                    Lists: []
                },
                rowindexcargo: '',
                issueDeptType: [], // 领料部门数组
                personType: 1, // 人员类型 1：保管员2：记账员
                visAddType: false,
                negativeflag: 0,
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
                scrollTop3:0,
                scrollTop4:0,
                showCollsoPrint:false,
                printerid:'',
                selectPrinterDetail:{
                    id:'',
                    ip:'',
                    model:'',
                    name:''
                },
                printerArr:[],
                showPrinter:false,
                showEditPrinter:false,
                printerDetail:{
                    id:'',
                    ip:'',
                    model:'',
                    name:''
                },
                addoreditprint: 1,//1新增2编辑
            };
        },
        watch: {
            /*dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataSet1: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataSet2: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            'dataDetail.MasterLists': function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(this.RightSelectIndex)
                })
            },*/
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('2_collsoissueview', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.issueDeptType = Array.methods.getIssueDeptWithPFLAG();
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.confirmAdd()
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if (form.name == 'prorelation' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.getDetail(data.order_no);
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
                that.$refs.singleTable3.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop3 = res.target.scrollTop
                },false)
                that.$refs.singleTable4.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop4 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop2;
                    this.$refs.singleTable3.bodyWrapper.scrollTop =this.scrollTop3;
                    this.$refs.singleTable4.bodyWrapper.scrollTop =this.scrollTop4;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[4009]"),this.$t("getapi[6588]"));
            },
            tableRowClassNameDetailMaster({row, rowIndex}){
                row.index = rowIndex;
            },
            tableRowClassNameDetailMerge({row, rowIndex}){
                row.index = rowIndex;
                // if (row.assist_measure_unit != null && row.assist_measure_unit != '') {
                //     return 'hidden-row';
                // }
                if(row.merge_qty > row.qty_on_hand){
                    return 'red'
                }
            },
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('ProSOCollecIssueHeadJichengViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                console.log('权限' + that.$limits.authority('plv2', 288, 1))
                console.log('权限' + that.$limits.authority('plv3', 288, 1))
                if(!this.$limits.menuvisible("plv2", 288, 1)){
                    var value = that.$limits.newOperationAuthorityView('plv2', 287, 1, that.total);
                    that.$refs.SetBtn.SetButtonEnable(value);
                } else {
                    if (that.$limits.authority('plv2', 288, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv2', 288, 1) == 2) {
                        if (that.$limits.authority('plv3', 350,1) == 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 350,1) == 1) {
                            //编辑级
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                        }
                        if (that.$limits.authority('plv3', 350, 1) == 2) {
                            //删除级
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)) {
                                if(that.dataDetail.Head.order_status > 0){
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export,print');
                                }
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,execute,print');
                            }
                        }
                    }
                }
                if(that.dataDetail.Head.order_status == 0 && that.dataDetail.Head.order_no != '') {
                    console.log(that.$limits.authority('plv2', 279, 1))
                    if (that.$limits.authority('plv2', 279, 1) > 0) {
                        that.$refs.SetBtn.SetOneBtnEnable('execute', true);
                    } else {
                        that.$refs.SetBtn.SetOneBtnEnable('execute', false);
                    }
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this
                that.btn.batchdelmaster = false
                that.btn.assistsadd=false
                that.btn.batchdelmerge = false
                if(that.dataDetail.Head.order_status == 0){
                    if(that.selectDataMater.length > 0 ){
                        that.btn.batchdelmaster = true
                    }
                    if(that.selectDataMerge.length > 0 ){
                        that.btn.batchdelmerge = true
                    }
                }
                if (that.$limits.authority('plv4', 591, 1) > 0 && that.dataDetail.Head.order_status==0) {
                    that.btn.assistsadd=true 
                } else {
                    that.btn.assistsadd=false
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('2_collsoissueview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            handleSizeChange1(val) {
                this.pageSize1 = val;
                this.$http.savePageSize('2_collsoissueview1',val)
                this.getView();
            },
            handleCurrentChange1(val) {
                this.pageIndex1 = val;
                this.getView();
            },
            handleSizeChange2(val) {
                this.pageSize2 = val;
                this.$http.savePageSize('2_collsoissueview2',val)
                this.getView();
            },
            handleCurrentChange2(val) {
                this.pageIndex2 = val;
                this.getView();
            },
            selectInfo(tab, event) {
                let that = this;
                that.SelectIndex = tab.name;
                that.getView();
                that.$nextTick(function(){
                    //that.$processdata.initForm(that.SelectIndex)
                });
            },
            selectInfo1(tab, event) {
                let that = this;
                that.RightSelectIndex = tab.name;
                that.$nextTick(function(){
                    //that.$processdata.initFormRight(that.RightSelectIndex)
                });
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'ProSOCollecIssueHeadJichengViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                that.$http.urlpost('/Pro/CollSO/CollSOViewList', data, function (res) {
                    if (res.Success == 1) {
                        if (that.SelectIndex == 0) {
                            that.dataSet = res.DataContent;
                            that.total = res.Totals;
                        } else if (that.SelectIndex == 1) {
                            that.dataSet1 = res.DataContent;
                            that.total1 = res.Totals;
                        } else if (that.SelectIndex == 2) {
                            that.dataSet2 = res.DataContent;
                            that.total2 = res.Totals;
                        }
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    that.$nextTick(function () {
                        that.$processdata.initAllForm()
                    })
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this
                if(that.code == row.order_no){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(!this.$limits.menuvisible("plv2", 288, 1)){
                        return
                    }
                    let datacopy = that.dataDetail
                    for(let i = 0;i<datacopy.MasterLists.length;i++){
                        delete datacopy.MasterLists[i]['index']
                    }
                    for(let i = 0;i<datacopy.MergeLists.length;i++){
                        delete datacopy.MergeLists[i]['index']
                    }
                    if(that.oldDataDetail != JSON.stringify(datacopy)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.code = row.order_no
                                that.getDetail(row.order_no)
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                if (that.SelectIndex == 0) {
                                    that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 1) {
                                    that.$refs.singleTable1.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 2) {
                                    that.$refs.singleTable2.$refs.singleTable.setCurrentRow(that.oldrow);
                                }
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.code = row.order_no
                        that.getDetail(row.order_no)
                    }
                }, 100);
            },
            print() {
            //询问
            let that = this;
            if(that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)){ return; }
            let TName = '21集成发料单.xlsx';
            that.$refs.SetBtn.SetOneBtnEnable('print', false);
            that.loading = true;
            let parm = {
                po_no: that.dataDetail.Head.order_no,
                TemplateName: TName
            };
            that.$http.urlpost('/Print/SCPrint', parm, function (res) {
                that.$refs.SetBtn.SetOneBtnEnable('print', true);
                if (res.Success == 1) {
                    let hrefurl = res.Key;
                    window.open(hrefurl);
                }
                that.loading = false;
            });
            },
            /*confirmPrint(){
                let that = this;
                that.visPrintType = false;
                let TName = '16生产领料单.xlsx';
                if(that.printflag==1){
                    TName = '17生产退料单.xlsx';
                }
                that.$refs.SetBtn.SetOneBtnEnable('print', false);
                that.loading = true;
                let parm = {
                    po_no: that.dataDetail.Head.order_no,
                    TemplateName: TName
                };
                that.$http.urlpost('/Print/LLPrint', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('print', true);
                    if (res.Success == 1) {
                        let hrefurl = res.Key;
                        window.open(hrefurl);
                    } 
                    that.loading = false;
                });
            },*/
            // 新增
            add() {
                let that = this;
                that.negativeflag = 0
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.MasterLists.length;i++){
                    delete datacopy.MasterLists[i]['index']
                }
                for(let i = 0;i<datacopy.MergeLists.length;i++){
                    delete datacopy.MergeLists[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.visAddType = true
                        });
                } else {
                    that.openEdit()
                    that.visAddType = true
                }
            },
            confirmAdd(){
                let that = this;
                that.visAddType = false
                that.addoredit = 0
                that.code = ''
                let date = Common.methods.getDate()
                that.dataDetail.Head = {
                    order_no: '',
                    so_code: '',
                    routing_sequence_no: 0,
                    routing_sequence_name: '',
                    order_status: 0,
                    order_status_name: '生成',
                    coll_sign: '',
                    boardspecial_flag: 0,
                    finance_status: -1,
                    finance_status_name: '',
                    finance_date: '',
                    issue_dept: '',
                    create_person: '',
                    create_time: '',
                    modify_person: '',
                    modify_time: '',
                    audit_person: '',
                    audit_time: '',
                    regist_person: '',
                    keep_person: '',
                    negative_flag: that.negativeflag,
                    base_order_no: '',
                    remark: '',
                    po_code: '',
                    vender_code: '',
                    vender_name: '',
                    verify_type: 0,
                    order_type: 0,
                    concurrent_time: ''
                }
                that.dataDetail.MasterLists = []
                that.dataDetail.MergeLists = []
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
                /*let that = this;
                if(that.addoredit == 0){
                    that.add()
                } else {
                    that.getDetail(that.code)
                }
                that.getView();*/
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.MasterLists.length;i++){
                    delete datacopy.MasterLists[i]['index']
                }
                for(let i = 0;i<datacopy.MergeLists.length;i++){
                    delete datacopy.MergeLists[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.getView();
                            if(that.addoredit == 0){
                                that.confirmAdd()
                            } else {
                                that.getDetail(that.code)
                            }
                        });
                } else {
                    if(that.addoredit == 0){
                        that.getView();
                        that.confirmAdd()
                    } else {
                        that.getView();
                        that.getDetail(that.code)
                    }
                }
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Pro/CollSO/CollSOViewExportToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "ProSOCollecIssueHeadJichengViewInfo",
                    fromname: that.$t('getapi[4009]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 保存
            save() {
                let that = this;
                for (let i = 0; i < that.dataDetail.MergeLists.length; i++) {
                    delete that.dataDetail.MergeLists[i]['areaarr'];
                }
                that.dataDetail.LangType= that.$processdata.getLang();
                let parm = that.dataDetail;
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.$refs.SetBtn.SetOneBtnEnable('execute', false)
                that.$http.urlpost('/Pro/CollSO/CollSOSave', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    that.$refs.SetBtn.SetOneBtnEnable('execute', true)
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.code = res.UniqueNum
                        that.getDetail(res.UniqueNum)
                    }
                });
            },
            getDetail(code) {
                let that = this;
                that.addoredit = 1
                let parm = {
                    Code: code
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Pro/CollSO/GetCollSOBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        for(let i = 0;i<that.dataDetail.MergeLists.length;i++){
                            if(that.dataDetail.MergeLists[i].area_code_list.length > 0){
                                that.dataDetail.MergeLists[i].areaarr = that.dataDetail.MergeLists[i].area_code_list.split(',')
                            } else {
                                that.dataDetail.MergeLists[i].areaarr = []
                            }
                        }
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                        that.btnauthority()
                    }
                    loadingInstance.close()
                    that.$nextTick(function () {
                        that.$processdata.initAllForm()
                    })
                });
            },
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no: that.dataDetail.Head.order_no,
                            concurrent_time: that.dataDetail.Head.concurrent_time
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del',false);
                        that.$http.urlpost('/Pro/CollSO/DelCollSOBill', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del',true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            execute(){
                let that = this
                that.visProIssueExcute = true
                that.getCollSOActionBillInfo(that.dataDetail.Head.order_no)
                that.btn.saveCollSOActionData = true
            },
            // 获取蓝字明细
            getCollSOActionBillInfo(code){
                let that = this
                that.btn.saveCollSOActionData = true
                let parm = {
                    Code: code
                }
                that.$http.urlpost('/Inv/Action/GetCollSOActBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetailExcute = res.DataContent
                    }
                    else{
                        that.visProIssueExcute = false;
                    }
                });
            },
            saveCollSOActionData(value){
                let that = this
                that.dataDetailExcute.iscontinue=value
                let parm = that.dataDetailExcute                
                parm.LangType = that.$processdata.getLang()
                that.btn.saveCollSOActionData = false
                that.btn.closeExecute = false
                let loadingInstance = Loading.service(Common.maskoption1);
                that.$http.urlpost('/Inv/Action/ActCollSOSaveData', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    } else if(res.Success > 1){
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                                confirmButtonText: that.$t('getapi[1146]'),
                                cancelButtonText: that.$t('getapi[2054]'),
                                type: 'warning'
                            })
                                .then(() => {
                                    that.saveCollSOActionData(res.Success)
                                })
                                .catch(() => {
                                    this.$message({
                                        type: 'info',
                                        message: that.$t('getapi[6096]')
                                    });
                                });
                    }
                    else {
                        that.btn.saveCollSOActionData = true
                    }
                    that.btn.closeExecute = true
                    loadingInstance.close()
                });
            },
            // 选择货位
            selectcargo(row){
                let that = this;
                that.rowindexcargo = row.$index
                that.$refs.cargo.clearInput(true);
            },
            getcargo(data){
                let that = this
                console.log(data)
                that.dataDetailExcute.Lists[that.rowindexcargo].cargo_position = data.cargoposition_code
            },
            // 选择发料单号
            selectorderno(row){
                let that = this;
                that.$refs.orderno.clearInput(true);
            },
            getorderno(data){
                let that = this
                console.log(data)
                that.dataDetailExcute.Head.order_no = data.order_no
                that.dataDetailExcute.Head.issue_dept = data.issue_dept
                that.dataDetailExcute.Head.negative_flag = data.negative_flag
                that.getCollSOActionBillInfo(that.dataDetailExcute.Head.order_no)
            },
            selectsocode_assist(){
                let that = this;
                that.oneormore = 1
                let param = {
                    negative_flag: that.dataDetail.Head.negative_flag
                }
                that.$refs.socode_assist.clearInput(true, param);
            },
            getsocode_assist(data){
                let that = this
                console.log(data)
                for (let i = 0; i < that.dataDetail.MergeLists.length; i++) {
                    delete that.dataDetail.MergeLists[i]['areaarr'];
                }
                let parm = {
                    Head: that.dataDetail.Head,
                    selList: data,
                    MasterLists: that.dataDetail.MasterLists,
                    MergeLists: that.dataDetail.MergeLists
                }
                let loadingInstance = Loading.service(Common.maskoption1);
                that.$http.urlpost('/Pro/CollSO/GetCollSOInfoSelPartNo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail.MasterLists = res.DataContent.MasterLists
                        that.dataDetail.MergeLists = res.DataContent.MergeLists
                        for(let i = 0;i<that.dataDetail.MergeLists.length;i++){
                            if(that.dataDetail.MergeLists[i].area_code_list.length > 0){
                                that.dataDetail.MergeLists[i].areaarr = that.dataDetail.MergeLists[i].area_code_list.split(',')
                            } else {
                                that.dataDetail.MergeLists[i].areaarr = []
                            }
                        }
                    }
                    loadingInstance.close()
                    that.$nextTick(function () {
                        that.$processdata.initAllForm()
                    })
                });
                that.btnauthority()
            },
            selectsocode(){
                let that = this;
                that.oneormore = 1
                let param = {
                    negative_flag: that.dataDetail.Head.negative_flag
                }
                that.$refs.socode.clearInput(true, param);
            },
            getsocode(data){
                let that = this
                console.log(data)
                for (let i = 0; i < that.dataDetail.MergeLists.length; i++) {
                    delete that.dataDetail.MergeLists[i]['areaarr'];
                }
                let parm = {
                    Head: that.dataDetail.Head,
                    selList: data,
                    MasterLists: that.dataDetail.MasterLists,
                    MergeLists: that.dataDetail.MergeLists
                }
                let loadingInstance = Loading.service(Common.maskoption1);
                that.$http.urlpost('/Pro/CollSO/GetCollSOInfoSelPartNo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail.MasterLists = res.DataContent.MasterLists
                        that.dataDetail.MergeLists = res.DataContent.MergeLists
                        for(let i = 0;i<that.dataDetail.MergeLists.length;i++){
                            if(that.dataDetail.MergeLists[i].area_code_list.length > 0){
                                that.dataDetail.MergeLists[i].areaarr = that.dataDetail.MergeLists[i].area_code_list.split(',')
                            } else {
                                that.dataDetail.MergeLists[i].areaarr = []
                            }
                        }
                    }
                    loadingInstance.close()
                    that.$nextTick(function () {
                        that.$processdata.initAllForm()
                    })
                });
                /*// 去重
                if(that.dataDetail.MasterLists.length > 0){
                    data = data.filter(item => {
                        return that.dataDetail.MasterLists.every(item2 => {
                            return item.so_code + item.routing_sequence_no + item.part_code + item.part_version != item2.so_code + item2.routing_sequence_no + item2.part_code + item2.part_version;
                        });
                    })
                }
                // 行号
                that.dataDetailLineNo = 1
                for (let i = 0; i < that.dataDetail.MasterLists.length; i++) {
                    if (that.dataDetail.MasterLists[i].line_no >= that.dataDetailLineNo) {
                        that.dataDetailLineNo = that.dataDetail.MasterLists[i].line_no + 1
                    }
                }
                let MLineNo = 1
                for (let i = 0; i < that.dataDetail.MergeLists.length; i++) {
                    if (that.dataDetail.MergeLists[i].line_no >= MLineNo) {
                        MLineNo = that.dataDetail.MergeLists[i].line_no + 1
                    }
                }
                for(let i = 0;i<data.length;i++){
                    let TempCreateQty
                    let token = that.userData.token;
                    let parm = {
                        so_code: data[i].so_code,
                        part_code: data[i].part_code,
                        part_version: data[i].part_version
                    }
                    $.ajax({
                        url: Common.Url + '/Pro/CollSO/GetOrderQCreateQty?token=' + token,
                        type: 'post',
                        async: false,
                        data: JSON.stringify(parm),
                        contentType: 'application/json',
                        success: function (res) {
                            if (res.Success == 1) {
                                TempCreateQty = res.DataContent
                            }
                        }
                    });
                    that.dataDetail.MasterLists = [...that.dataDetail.MasterLists,{
                        exclusively_id:'',
                        relation_order_no:'',
                        line_no:that.dataDetailLineNo++,
                        relation_stuff_id:0,
                        part_code:data[i].part_code,
                        part_version:data[i].part_version,
                        part_name:data[i].part_name,
                        board_flag:'',
                        part_spec:data[i].part_spec,
                        part_model:data[i].part_model,
                        mp_flag:data[i].mp_flag=='采购件'?0:1,
                        mp_flag_name:data[i].mp_flag,
                        so_code:data[i].so_code,
                        so_qty:'',
                        routing_sequence_no:data[i].routing_sequence_no,
                        routing_desc:data[i].routing_desc,
                        measure_unit:data[i].part_master_unit,
                        plan_qty:data[i].plan_qty - TempCreateQty,
                        assist_plan_qty:'',
                        actually_avg_qty:data[i].plan_qty - TempCreateQty,
                        unit_price:'',
                        line_net_total_amount:'',
                        line_remark:"",
                        po_line_id:'',
                        assist_actually_avg_qty:'',
                        assist_measureunit:'',
                        master_assist_rate:data[i].master_assist_rate,
                        inv_qty:'',
                        issue_material_unit:'',
                        issue_material_amount:'',
                        issue_man_unit:'',
                        issue_man_amount:'',
                        issue_charge_unit:'',
                        issue_charge_amount:'',
                        item_code:"",
                        workcenter_code:data[i].workcenter_code,
                        cargo_position:data[i].cargo_position,
                        create_qty:'',
                        workcenter_name:data[i].workcenter_name
                    }]
                    let MergeIsExists = false
                    for(let j=0;j<that.dataDetail.MergeLists.length;j++){
                        if(that.dataDetail.MergeLists[j].part_code == data[i].part_code && that.dataDetail.MergeLists[j].part_version == data[i].part_version){
                            that.dataDetail.MergeLists[j].merge_qty = that.dataDetail.MergeLists[j].merge_qty + data[i].plan_qty - TempCreateQty
                            if(data[i].master_assist_rate != 0){                                
                                that.dataDetail.MergeLists[j].assist_merge_qty = that.dataDetail.MergeLists[j].merge_qty / data[i].master_assist_rate
                                that.dataDetail.MergeLists[j].assist_measure_unit = data[i].part_assist_unit
                            }
                            MergeIsExists = true;
                            break;
                        }
                    }
                    if(!MergeIsExists){
                        let CreateQty
                        let parm1 = {
                            order_no: that.dataDetail.Head.order_no,
                            part_code: data[i].part_code,
                            part_version: data[i].part_version
                        }
                        $.ajax({
                            url: Common.Url + '/Pro/CollSO/GetSetCreateQty?token=' + token,
                            type: 'post',
                            async: false,
                            data: JSON.stringify(parm1),
                            contentType: 'application/json',
                            success: function (res) {
                                if (res.Success == 1) {
                                    CreateQty = res.DataContent
                                }
                            }
                        });
                        let OnHand
                        let parm2 = {
                            part_code: data[i].part_code,
                            part_version: data[i].part_version,
                            negative_flag: that.dataDetail.Head.negative_flag
                        }
                        $.ajax({
                            url: Common.Url + '/Pro/CollSO/GetPartStockQty?token=' + token,
                            type: 'post',
                            async: false,
                            data: JSON.stringify(parm2),
                            contentType: 'application/json',
                            success: function (res) {
                                if (res.Success == 1) {
                                    OnHand = res.DataContent
                                }
                            }
                        });
                        that.dataDetail.MergeLists = [...that.dataDetail.MergeLists,{
                            exclusively_id:'',
                            relation_order_no:'',
                            line_no:MLineNo++,
                            part_code:data[i].part_code,
                            part_version:data[i].part_version,
                            part_name:data[i].part_name,
                            part_spec:data[i].part_spec,
                            part_model:data[i].part_model,
                            measure_unit:data[i].part_master_unit,
                            assist_measure_unit:data[i].master_assist_rate != 0 ? data[i].part_assist_unit : '',
                            merge_qty:data[i].plan_qty - TempCreateQty,
                            assist_merge_qty: data[i].master_assist_rate != 0 ? (data[i].plan_qty - TempCreateQty) / data[i].master_assist_rate : '',
                            master_assist_rate:data[i].master_assist_rate != 0 ? data[i].master_assist_rate : '',
                            qty_on_hand:OnHand,
                            createqty:CreateQty,
                            mp_flag:data[i].mp_flag,
                            cargo_position:data[i].cargo_position
                        }]
                    } else {
                        let sum = 0
                        for(let j = 0;j<that.dataDetail.MasterLists.length;j++){
                            if(that.dataDetail.MasterLists[j].part_code == data[i].part_code && that.dataDetail.MasterLists[j].part_version == data[i].part_version){
                                sum =that.addNum(sum,that.dataDetail.MasterLists[j].plan_qty)
                                that.dataDetail.MasterLists[j].actually_avg_qty = that.dataDetail.MasterLists[j].plan_qty
                            }
                        }
                        for(let k = 0;k<that.dataDetail.MergeLists.length;k++){
                            if(that.dataDetail.MergeLists[k].part_code == data[i].part_code && that.dataDetail.MergeLists[k].part_version == data[i].part_version){
                                that.dataDetail.MergeLists[k].merge_qty = sum
                                if(data[i].master_assist_rate != 0){
                                    that.dataDetail.MergeLists[k].assist_merge_qty = sum / data[i].master_assist_rate
                                }
                            }
                        }
                    }
                }*/
                that.btnauthority()
            },
            addNum (num1, num2) {
                num1 == undefined ? num1 = 0 : ''
                num2 == undefined ? num2 = 0 : ''
                var sq1, sq2, m;
                try {
                    sq1 = num1.toString().split(".")[1].length;
                }
                catch (e) {
                    sq1 = 0;
                }
                try {
                    sq2 = num2.toString().split(".")[1].length;
                }
                catch (e) {
                    sq2 = 0;
                }
                m = Math.pow(10, Math.max(sq1, sq2));
                return (num1 * m + num2 * m) / m;
            },
            batchDel(){
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no: that.dataDetail.Head.order_no,
                            concurrent_time: that.dataDetail.Head.concurrent_time,
                            Lists: []
                        };
                        for (let i = that.selectDataMater.length - 1; i >= 0; i--) {
                            if(that.selectDataMater[i].exclusively_id!=""){
                                parm.Lists = [...parm.Lists,{
                                    line_no: that.selectDataMater[i].line_no,
                                    part_code: that.selectDataMater[i].part_code,
                                    part_version: that.selectDataMater[i].part_version
                                }]
                            }
                        }
                        if(parm.Lists.length>0){
                            that.$http.urlpost('/Pro/CollSO/DelCollSoLine', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    that.getDetail(that.code);
                                }
                            });
                        } else {
                            for(let i = that.selectDataMater.length - 1;i >= 0; i--){
                                let sum = 0
                                for(let j = 0;j<that.dataDetail.MasterLists.length;j++){
                                    if(that.selectDataMater[i].index != that.dataDetail.MasterLists[j].index && that.selectDataMater[i].part_code == that.dataDetail.MasterLists[j].part_code && that.selectDataMater[i].part_version == that.dataDetail.MasterLists[j].part_version){
                                        sum =(that.addNum(sum,that.dataDetail.MasterLists[j].actually_avg_qty)).toFixed(4)
                                    }
                                }
                                if(sum != 0){
                                    for(let j = 0;j < that.dataDetail.MergeLists.length;j++){
                                        if(that.selectDataMater[i].part_code == that.dataDetail.MergeLists[j].part_code && that.selectDataMater[i].part_version == that.dataDetail.MergeLists[j].part_version){
                                            that.dataDetail.MergeLists[j].merge_qty = sum
                                            if(that.dataDetail.MergeLists[j].assist_measure_unit != ''){
                                                that.dataDetail.MergeLists[j].assist_merge_qty =( sum / parseFloat(that.dataDetail.MergeLists[j].master_assist_rate)).toFixed(4)
                                            }
                                            break
                                        }
                                    }
                                } else {
                                    for(let j = that.dataDetail.MergeLists.length - 1;j >= 0;j--){
                                        if(that.selectDataMater[i].part_code == that.dataDetail.MergeLists[j].part_code && that.selectDataMater[i].part_version == that.dataDetail.MergeLists[j].part_version){
                                            that.dataDetail.MergeLists.splice(j,1)
                                            break
                                        }
                                    }
                                }
                                for(let j = 0;j <that.dataDetail.MasterLists.length;j++){
                                    if(that.dataDetail.MasterLists[j].index == that.selectDataMater[i].index){
                                        that.dataDetail.MasterLists.splice(j, 1);
                                    }
                                }
                                /*that.dataDetail.MasterLists.splice(that.selectDataMater[i].index, 1);*/
                            }
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            batchDelMerge(){
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no: that.dataDetail.Head.order_no,
                            concurrent_time: that.dataDetail.Head.concurrent_time,
                            Lists: []
                        };
                        for (let i = that.selectDataMerge.length - 1; i >= 0; i--) {
                            if(that.selectDataMerge[i].exclusively_id!=""){
                                parm.Lists = [...parm.Lists,{
                                    line_no: that.selectDataMerge[i].line_no,
                                    part_code: that.selectDataMerge[i].part_code,
                                    part_version: that.selectDataMerge[i].part_version
                                }]
                            }
                        }
                        if(parm.Lists.length>0){
                            that.$http.urlpost('/Pro/CollSO/DelCollSoMerge', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    that.getDetail(that.code);
                                }
                            });
                        } else {
                            for(let i = that.selectDataMerge.length - 1;i >= 0; i--){
                                for(let j = that.dataDetail.MasterLists.length - 1;j >= 0; j--){
                                    if(that.selectDataMerge[i].part_code == that.dataDetail.MasterLists[j].part_code && that.selectDataMerge[i].part_version == that.dataDetail.MasterLists[j].part_version){
                                        that.dataDetail.MasterLists.splice(j,1)
                                    }
                                }
                                for(let j = 0;j <that.dataDetail.MergeLists.length;j++){
                                    if(that.dataDetail.MergeLists[j].index == that.selectDataMerge[i].index){
                                        that.dataDetail.MergeLists.splice(j, 1);
                                    }
                                }
                                /*that.dataDetail.MergeLists.splice(that.selectDataMerge[i].index, 1);*/
                            }
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            selectperson(val){
                let that = this;
                that.personType = val
                that.$refs.person.clearInput(true);
            },
            getperson(data){
                let that = this
                console.log(data)
                if(that.personType == 1){
                    that.dataDetail.Head.keep_person = data.name
                } else if(that.personType == 2){
                    that.dataDetail.Head.regist_person = data.name
                }
            },
            handleSelectionChangeMaster(val) {
                let that = this;
                that.selectDataMater = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectDataMater.push(val[i]);
                }
                that.btnauthority();
            },
            handleSelectionChangeMerge(val) {
                let that = this;
                that.selectDataMerge = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectDataMerge.push(val[i]);
                }
                that.btnauthority();
            },
            changeQtyBlue(row){
                let that = this
                let index = row.$index                
                if(!that.$limits.fnIsEmpty(that.dataDetailExcute.Lists[index].assist_measureunit)){
                    if(that.dataDetailExcute.Lists[index].master_assist_rate>0 && that.dataDetailExcute.Lists[index].assist_qty_on_hand>0){
                        let qty = parseFloat(that.dataDetailExcute.Lists[index].trans_qty_input) / parseFloat(that.dataDetailExcute.Lists[index].master_assist_rate);
                        that.dataDetailExcute.Lists[index].assist_trans_qty_input = that.$processdata.mathRound4(qty)
                    }
                    else
                    {
                        that.dataDetailExcute.Lists[index].assist_trans_qty_input=0;
                    }
                }
            },
            // 详情次数量改变
            changeAssistQtyBlue(row){
                let that = this
                let index = row.$index
                if(!that.$limits.fnIsEmpty(that.dataDetailExcute.Lists[index].assist_measureunit)){                    
                    if(that.dataDetailExcute.Lists[index].master_assist_rate>0 && that.dataDetailExcute.Lists[index].assist_qty_on_hand>0){                        
                        let qty = parseFloat(that.dataDetailExcute.Lists[index].assist_trans_qty_input) * parseFloat(that.dataDetailExcute.Lists[index].master_assist_rate);
                        that.dataDetailExcute.Lists[index].trans_qty_input = that.$processdata.mathRound4(qty)
                    }
                }
            },
            mergeQtyCalc(row){
                let that = this
                let newAssistQty = row.merge_qty / row.master_assist_rate
                if(row.assist_merge_qty - newAssistQty > 1){
                    that.$message.warning(that.$t('getapi[12994]'))//'次合并发料数与次发料数差值不能大于1,请重新填写集成发料数!'
                    row.merge_qty = (row.assist_merge_qty * row.master_assist_rate).toFixed(4)
                } else {
                    that.setSoQty(row)
                }
            },
            setSoQty(row){
                console.log("测试1133");
                let that = this
                let PartCode = row.row.part_code
                let PartVersion = row.row.part_version
                let NewSumQty = row.row.merge_qty
                let sum = 0
                let maxi = -1
                let maxd = 0

                for(let i = 0;i<that.dataDetail.MergeLists.length; i++){
                    if(that.dataDetail.MergeLists[i].part_code == PartCode && that.dataDetail.MergeLists[i].part_version == PartVersion){
                        if(that.dataDetail.MergeLists[i].master_assist_rate>0 && !that.$limits.fnIsEmpty(that.dataDetail.MergeLists[i].assist_measure_unit)){
                            let qty = parseFloat(that.dataDetail.MergeLists[i].merge_qty) / parseFloat(that.dataDetail.MergeLists[i].master_assist_rate);
                            that.dataDetail.MergeLists[i].assist_merge_qty = (that.$processdata.mathRound4(qty)).toFixed(4)
                        }
                    }
                }

                for(let i = 0;i<that.dataDetail.MasterLists.length; i++){
                    if(that.dataDetail.MasterLists[i].part_code == PartCode && that.dataDetail.MasterLists[i].part_version == PartVersion){
                        if(maxi == -1){
                            maxd = (parseFloat(that.dataDetail.MasterLists[i].plan_qty)).toFixed(4)
                            maxi = i
                        }
                        sum = sum + parseFloat(that.dataDetail.MasterLists[i].plan_qty)
                        if(parseFloat(that.dataDetail.MasterLists[i].plan_qty) > maxd){
                            maxd = (parseFloat(that.dataDetail.MasterLists[i].plan_qty)).toFixed(4)
                            maxi = i
                        }
                    }
                }
                if(sum != 0 ){
                    for(let i = 0;i<that.dataDetail.MasterLists.length; i++){
                        if(that.dataDetail.MasterLists[i].part_code == PartCode && that.dataDetail.MasterLists[i].part_version == PartVersion){
                            let qty = parseFloat(that.dataDetail.MasterLists[i].plan_qty) / sum * NewSumQty
                            that.dataDetail.MasterLists[i].actually_avg_qty = (that.$processdata.mathRound4(qty)).toFixed(4)
                        }
                    }
                    let newsum = 0
                    for(let i = 0;i<that.dataDetail.MasterLists.length; i++){
                        if(that.dataDetail.MasterLists[i].part_code == PartCode && that.dataDetail.MasterLists[i].part_version == PartVersion){
                            newsum = that.$processdata.floatAdd(newsum , parseFloat(that.dataDetail.MasterLists[i].actually_avg_qty))
                        }
                    }
                    if(newsum != NewSumQty){
                        if(that.dataDetail.MasterLists.length > 0){
                            // console.log("测试序号:"+maxi)
                            // console.log("测试ZH:"+parseFloat(that.dataDetail.MasterLists[maxi].actually_avg_qty))
                            // console.log("测试HJ:"+parseFloat(NewSumQty))
                            // console.log("测试nHJ:"+parseFloat(newsum))
                            // console.log("测试AA:"+that.dataDetail.MasterLists[maxi].actually_avg_qty)
                            that.dataDetail.MasterLists[maxi].actually_avg_qty = that.$processdata.floatSub(that.$processdata.floatAdd(parseFloat(that.dataDetail.MasterLists[maxi].actually_avg_qty) + parseFloat(NewSumQty)) - parseFloat(newsum)).toFixed(4);
                        }
                    }
                }
            },
            expStatus(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[1422]')//'生成';
                } else if (val == 1) {
                    return that.$t('getapi[4587]')//'已执行';
                } else {
                    return '';
                }
            },
            expFinanceStatus(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[1901]')//'核算';
                } else if (val == 1) {
                    return that.$t('getapi[3753]')//'记账';
                } else if (val == 2) {
                    return that.$t('getapi[3754]')//'月结';
                } else {
                    return '';
                }
            },
            //打印
            collsoPrint(){
                let that = this
                let parm = {

                }
                that.$http.urlpost('/Print/GetPrinter', parm, function (res) {
                    if (res.Success == 1) {
                        if(res.DataContent){
                            that.printerArr = res.DataContent
                            that.printerid = window.localStorage.getItem('printerid') == undefined?'':parseInt(window.localStorage.getItem('printerid'))
                            for(let i=0;i<that.printerArr.length;i++){
                                if(that.printerid == that.printerArr[i].id){
                                    that.selectPrinterDetail = that.printerArr[i]
                                    break
                                }
                            }
                        }
                        that.showCollsoPrint = true
                    }
                });
            },
            changePrinter(val){
                let that = this
                console.log(val)
                for(let i=0;i<that.printerArr.length;i++){
                    if(val == that.printerArr[i].id){
                        that.selectPrinterDetail = that.printerArr[i]
                    }
                }
            },
            getPrinterArr(){
                let that = this
                that.$http.urlpost('/Print/GetPrinter', {}, function (res) {
                    if (res.Success == 1) {
                        that.printerArr = res.DataContent
                    }
                });
            },
            confirmCollsoPrint(){
                let  that = this
                that.printerid = window.localStorage.setItem('printerid', that.selectPrinterDetail.id)
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    id: that.selectPrinterDetail.id,
                    ip: that.selectPrinterDetail.ip,
                    model: that.selectPrinterDetail.model,
                    name: that.selectPrinterDetail.name
                }
                that.$http.urlpost('/Print/CollecIssuePrint', parm, function (res) {
                    if (res.Success == 1) {
                        let code = res.DataContent
                        let RequestData = { 'user': that.user,'data':code,'printer':that.selectPrinterDetail};
                        $.ajax({
                            url: that.selectPrinterDetail.ip,
                            type: 'post',
                            contentType: 'application/json',
                            data: JSON.stringify(RequestData),
                            success: function (res) {
                                that.showCollsoPrint = false
                            },
                            error: function (xhr, errorType, error) {

                            }
                        });
                    }
                });
            },
            editPrinter(){
                let that = this
                that.showPrinter = true
            },
            addPrinter(){
                let that = this
                that.showEditPrinter = true
                that.addoreditprint = 1
                that.printerDetail = {
                    id: '',
                    ip: '',
                    model: '',
                    name: ''
                };
            },
            editPrinter_(row) {
                let that = this
                that.showEditPrinter = true;
                that.addoreditprint = 2
                that.printerDetail = {
                    id: row.row.id,
                    ip: row.row.ip,
                    model: row.row.model,
                    name: row.row.name
                };
            },
            delPrinter_(row){
                let that = this
                let parm = {
                    id: row.row.id,
                    ip: row.row.ip,
                    model: row.row.model,
                    name: row.row.name
                }
                that.$http.urlpost('/Print/DeletePrinter', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.$http.urlpost('/Print/GetPrinter', {}, function (res) {
                            if (res.Success == 1) {
                                that.printerArr = res.DataContent
                            }
                        });
                    }
                });
            },
            savePrinter(){
                let that = this
                let parm = that.printerDetail
                if(that.addoreditprint == 1){
                    that.$http.urlpost('/Print/InsertPrinter', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.showEditPrinter = false
                            that.getPrinterArr()
                        }
                    });
                } else if(that.addoreditprint == 2){
                    that.$http.urlpost('/Print/UpdatePrinter', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.showEditPrinter = false
                            that.getPrinterArr()
                        }
                    });
                }
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 350,1) < 1){
                    return false
                }
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.MasterLists.length;i++){
                    delete datacopy.MasterLists[i]['index']
                }
                for(let i = 0;i<datacopy.MergeLists.length;i++){
                    delete datacopy.MergeLists[i]['index']
                }
                let flag =  that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .green {
        background: #c8ffbb;
    }
    /deep/ .red {
        color: #ff7879;
    }

    /deep/.el-table .hidden-row {
        display: none;
    }
</style>
